import { takeEvery, all, call, put, cancelled } from 'redux-saga/effects';

import {
  Inventories_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD,
  Inventories_MASSIVE_UPLOAD_REQUEST_VERIFY,
  Inventories_MASSIVE_UPLOAD_REQUEST_UPLOAD,
  InventoriesMassiveUploadSetAllowUpload,
  InventoriesMassiveUploadClearAllowUpload,
  InventoriesMassiveUploadSetVerify,
  InventoriesMassiveUploadClearVerify,
  InventoriesMassiveUploadClearUpload,
} from '../actions';

import instance from 'services/request';

import { responseOK } from 'Domains/SalesChallengeRefactor/utils';

import { InventoriesMassiveUpload } from '../../services';
import {
  fileTo64String,
  validateTypeAndSize,
  summaryModal,
  summaryEndModal,
} from 'common/MassiveUploads/utils';
import { messageError } from 'utils/messages';

function* workInventoriesMassiveUploadSetAllowUpload(action) {
  try {
    yield InventoriesMassiveUploadSetAllowUpload(action.payload);
  } catch (error) {
    yield InventoriesMassiveUploadClearAllowUpload();
    console.error(error);
  } finally {
    if (yield cancelled()) {
      yield InventoriesMassiveUploadClearAllowUpload();
    }
  }
}

function* workInventoriesMassiveUploadRequestVerify({ payload }) {
  const { file, setFileString, subregion } = payload;
  const CancelToken = instance.CancelToken;
  const source = CancelToken.source();
  try {
    const isValidFile = validateTypeAndSize(file);
    if (!isValidFile) {
      messageError(
        'El formato del archivo de carga masiva de inventarios iniciales debe ser .xlsx y tener un tamaño máximo de 20 MB.'
      );

      return;
    }

    const file64Str = yield call(fileTo64String, file);
    yield call(setFileString, file64Str);
    const response = yield call(InventoriesMassiveUpload, {
      cancelToken: source.token,
      data: {
        content: file64Str,
        overwrite: false,
        save: false,
        subregion: subregion,
      },
    });
    if (responseOK(response)) {
      let { data, message, allCorrectMessage } = response;
      let allCorrect = data.correct > 0 && data.totalErrors === 0;

      if (allCorrect) {
        data.allCorrectMessage = allCorrectMessage;
      }

      yield put(InventoriesMassiveUploadSetVerify(data));
      yield call(summaryModal, message, false);
    } else {
      yield put(InventoriesMassiveUploadClearVerify());
    }
  } catch (error) {
    yield InventoriesMassiveUploadClearVerify();
    console.error(error);
  } finally {
    if (yield cancelled()) {
      yield InventoriesMassiveUploadClearVerify();
      source.cancel('cancelled Request');
    }
  }
}

function* workInventoriesMassiveUploadRequestUpload({ payload }) {
  const { history, fileString, overwrite, subregion } = payload;
  const CancelToken = instance.CancelToken;
  const source = CancelToken.source();
  try {
    const response = yield call(InventoriesMassiveUpload, {
      cancelToken: source.token,
      data: {
        content: fileString,
        save: true,
        overwrite,
        subregion: subregion,
      },
    });
    if (responseOK(response)) {
      yield call(summaryEndModal, response.data, history, '/catalog/trade-agreement-info');
    } else {
      yield put(InventoriesMassiveUploadClearUpload());
    }
  } catch (error) {
    yield InventoriesMassiveUploadClearUpload();
    console.error(error);
  } finally {
    if (yield cancelled()) {
      yield InventoriesMassiveUploadClearUpload();
      source.cancel('cancelled Request');
    }
  }
}

export function* watchInventoriesMassiveUploadSetAllowUpload() {
  yield all([
    takeEvery(
      Inventories_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD,
      workInventoriesMassiveUploadSetAllowUpload
    ),
  ]);
}

export function* watchInventoriesMassiveUploadRequestVerify() {
  yield all([
    takeEvery(Inventories_MASSIVE_UPLOAD_REQUEST_VERIFY, workInventoriesMassiveUploadRequestVerify),
  ]);
}

export function* watchInventoriesMassiveUploadRequestUpload() {
  yield all([
    takeEvery(Inventories_MASSIVE_UPLOAD_REQUEST_UPLOAD, workInventoriesMassiveUploadRequestUpload),
  ]);
}
